import {
  useFormSection,
  useFormFieldGroup,
  useField
} from "@/components/FormBuilder/Helpers";

export const restrictOptions = [
  {
    label: "1",
    value: 1
  },
  {
    label: "2",
    value: 2
  },
  {
    label: "3",
    value: 3
  }
];

export const restrictedUserFormSchema = (
  isIndefinite?: boolean,
  showIndefiniteField?: boolean
) => {
  return useFormSection(
    useFormFieldGroup(
      [
        ...(showIndefiniteField
          ? [
              useField({
                key: "indefinite",
                label: "Restrict Indefinitely?",
                type: "checkbox",
                required: false
              })
            ]
          : []),

        useField({
          key: "startDate",
          label: "Start Date",
          type: "date",
          required: true
        }),

        useField({
          key: "endDate",
          label: "End Date",
          type: "date",
          required: true,
          disabled: isIndefinite
        })
      ],
      { layout: showIndefiniteField ? "3-col" : "2-col" }
    )
  );
};
